module.exports = __webpack_public_path__ + "static/img/mobile.9ebcce3b.svg";